<template>
  <div class="opponent-profile">
    <BaseSwiper
      ref="base-swiper"
      @slide-change="$store.commit('ui/setActiveOpponentProfileSlide', $event)"
      :options="{ direction: 'vertical', pagination: { el: null } }"
      :scrolling-content="true">
      <SwiperSlide>
        <Main
          ref="main"
          :opponent="opponent"
          :number-image="numberImage"
          @open-stats="$refs['base-swiper'].updateSlide(1)"
          :unlocked="unlocked"
        />
      </SwiperSlide>
      <SwiperSlide>
        <Stats
          :opponent="opponent"
          :unlocked="unlocked"
          @close-stats="$refs['base-swiper'].updateSlide(0)"
        />
      </SwiperSlide>
    </BaseSwiper>
  </div>
</template>

<script>
import Main from './partials/Main/Main'
import Stats from './partials/Stats/Stats'
import BaseSwiper from '@/components/BaseSwiper/BaseSwiper'
import SwiperSlide from '@/components/BaseSwiper/components/SwiperSlide/SwiperSlide'
import { mapState } from 'vuex'
export default {
  components: {
    Main,
    Stats,
    BaseSwiper,
    SwiperSlide
  },
  props: {
    opponent: {
      type: Object,
      required: true
    },
    numberImage: {
      type: String,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    this.tl = this.$refs['main'].tl
  },
  computed: mapState('ui', [
    'activeOpponentProfileSlide',
    'activeOpponentSlide'
  ]),
  watch: {
    activeOpponentProfileSlide (val) {
      this.$refs['base-swiper'].updateSlide(val)
    },
    activeOpponentSlide () {
      this.$refs['base-swiper'].resetScroll()
    }
  }
}
</script>

<style lang="scss" scoped>
.opponent-profile {
  width: 100%;
  height: 100%;
}
</style>
